interface LogoProps {
  size?: "sm" | "default" | "md" | "lg" | "xl" | "xxl";
  onDark?: boolean | "auto";
}

const GOLD = "#D4A843";
const NAVY = "#1B2A4A";

export function Logo({ size = "default", onDark = false }: LogoProps) {
  const fontSize = size === "xxl" ? 56 : size === "xl" ? 44 : size === "lg" ? 36 : size === "md" ? 32 : size === "sm" ? 20 : 28;
  const swooshHeight = size === "xxl" ? 18 : size === "xl" ? 16 : size === "lg" ? 14 : size === "md" ? 12 : size === "sm" ? 8 : 10;

  // For "auto" mode, use CSS variable so it reacts to theme toggle without re-render
  const careColor = onDark === "auto"
    ? "var(--color-logo-care)"
    : onDark ? "white" : NAVY;

  return (
    <span style={{ position: "relative", display: "inline-block", paddingBottom: size === "xxl" ? 14 : size === "xl" ? 12 : size === "lg" ? 10 : size === "md" ? 8 : 6 }}>
      <span style={{
        fontSize,
        fontFamily: "'DM Sans', system-ui, sans-serif",
        fontWeight: 800,
        letterSpacing: "-0.03em",
        lineHeight: 1,
        color: careColor,
      }}>
        Care
      </span>
      <span style={{
        fontSize,
        fontFamily: "'DM Sans', system-ui, sans-serif",
        fontWeight: 600,
        letterSpacing: "-0.02em",
        lineHeight: 1,
        color: GOLD,
      }}>
        Logic
      </span>
      <svg
        viewBox="0 0 160 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: swooshHeight,
        }}
      >
        <path
          d="M3 10C30 3 60 3 80 6C100 9 130 7 157 4"
          stroke={GOLD}
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </span>
  );
}
